<template>
  <div class="c-equipmentArchive__colFilter">
    <div class="c-equipmentArchive__filterWrapper">
      <div class="m-filter js-filter" v-bind:class="(filter_mobile_is_active) ? 'is-active' : ''">
        <div class="m-filter__background js-filter-close" v-on:click="closeFilterMobile"></div>
        <div class="m-filter__scroll">
          <div class="m-filter__container">
            <div class="m-filter__close">
              <button type="button" class="m-filter__close__btn js-filter-close" v-on:click="closeFilterMobile"></button>
            </div>
            <div class="m-filter__filter">
              <div class="m-filter__title Text--center">
                <h5 class="Margin--none">{{ mobile_title }}</h5>
              </div>
              <form action="">
                <div class="m-filter__search">
                  <div class="c-FormElement--boxed m-label js-label">
                    <label for="equipmentsearch">{{ search_label }}</label>
                    <input type="text" v-on:keydown.enter="apply" v-model="text" id="equipmentsearch">
                    <span class="c-FormElement--focusLine"></span>
                    <div class="m-filter__search--btn">
                      <button v-on:click="apply">
                        <div>
                          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="51.551" height="36.338" viewBox="0 0 51.551 36.338">
                            <g id="Group_166" data-name="Group 166" transform="translate(-559.5 -4810.549)">
                              <line id="Line_63" data-name="Line 63" x2="49.43" transform="translate(559.5 4828.718)" fill="none" stroke="#be161d" stroke-width="3"/>
                              <path id="Path_59" data-name="Path 59" d="M24.195,0V24.195H0" transform="translate(574.713 4828.718) rotate(-45)" fill="none" stroke="#be161d" stroke-width="3"/>
                            </g>
                          </svg>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                  <div class="m-filter__collapse">
                    <div class="m-filterCollapse">
                      <filter-recently-launched v-on:selection_recently_launched_values="selection_recently_launched_values = $event" :recently_launched="recently_launched" :selection_recently_launched_values="selection_recently_launched_values" :filter_row_state.sync="filter_row_state"></filter-recently-launched>
                      <filter-product-line v-on:selection_lines_values="selection_lines_values = $event" :lines="lines" :selection_lines_values="selection_lines_values" :filter_row_state.sync="filter_row_state"></filter-product-line>
                      <filter-body-part v-on:selection_body_parts_values="selection_body_parts_values = $event" :body_parts="body_parts" :selection_body_parts_values="selection_body_parts_values" :filter_row_state.sync="filter_row_state"></filter-body-part>
                      <filter-equipment-type v-on:selection_equipment_type_values="selection_equipment_type_values = $event" :types="equipment_types" :selection_equipment_type_values="selection_equipment_type_values" :filter_row_state.sync="filter_row_state"></filter-equipment-type>
                    </div>
                  </div>
                <div class="m-filter__btn">
                  <div>
                    <button class="c-Btn--bordered" v-on:click="apply">{{ button_title }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import FilterProductLine from "./FilterProductLine";
import FilterBodyPart from "./FilterBodyPart";
import FilterEquipmentType from "./FilterEquipmentType";
import FilterRecentlyLaunched from "./FilterRecentlyLaunched.vue";

export default {
  name: "Filters",
  components: {FilterEquipmentType, FilterBodyPart, FilterProductLine, FilterRecentlyLaunched},
  props: [
    'lines',
    'selection_lines',
    'body_parts',
    'selection_body_parts',
    'equipment_types',
    'selection_equipment_type',
    'recently_launched',
    'selection_recently_launched',
    'filter_mobile_is_active'
  ],
  data() {
    return {
      selection_lines_values: [],
      selection_body_parts_values:[],
      selection_equipment_type_values:[],
      selection_recently_launched_values:[],
      collapse: true,
      text: '',
      filter_mobile_state: this.filter_mobile_is_active,
      filter_row_state: {
        product_line: false,
        body_part: false,
        equipment_type: false,
        recently_launched: false
      },
      // translation
      mobile_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.mobile_title : '',
      search_label: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.search_label : '',
      button_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.button_title : '',
    }
  },
  watch:{
    selection_lines:function(newVal){
      this.selection_lines_values = newVal.map(x => x.term_id);
    },
    selection_body_parts:function(newVal){
      this.selection_body_parts_values = newVal.map(x => x.post_id);
    },
    selection_equipment_type:function(newVal){
      this.selection_equipment_type_values = newVal.map(x => x.term_id);
    },
    selection_recently_launched:function(newVal){
      this.selection_recently_launched_values = newVal.map(x => x.term_id);
    }
  },
  methods: {
    apply: function(e){
        e.preventDefault();
        const selection_equipment = {
            lines: this.selection_lines_values,
            body_parts: this.selection_body_parts_values,
            equipment_type: this.selection_equipment_type_values,
            recently_launched: this.selection_recently_launched_values
        };
        window.sessionStorage.setItem('atlantis_equipment', JSON.stringify(selection_equipment));
        this.$emit('apply', this.selection_lines_values, this.selection_body_parts_values, this.selection_equipment_type_values, this.selection_recently_launched_values, this.text, 1);
        this.closeFilterMobile();
    },
    closeFilterMobile: function() {
      this.$emit('update:filter_mobile_is_active', this.filter_mobile_state);
      window.Store.app.theBody.classList.remove('filter-active');
    }
  },
}
</script>
